import * as React from "react";
import { AskAboutQuery_Tip } from "../../../../graphql-types";
import Image from "../image/image";
import TipBunny from "../../../images/answer-bunny-look-right.svg";
import styles from "./text-answer-tip.styles";

const TextAnswerTip: React.FC<AskAboutQuery_Tip> = ({ title, description }) => {
  return (
    <div css={styles.root}>
      <div css={styles.heading}>{title}</div>
      <div dangerouslySetInnerHTML={{ __html: description }} />
      <Image src={TipBunny} alt="Ask About Bunny" css={styles.image} />
    </div>
  );
};

export default TextAnswerTip;
